import React, { forwardRef, Suspense } from "react";
import { isSSR } from "./../wix-rich-content-common";
import { DevContextProvider, shouldShowDebuggingInfo } from "./../wix-rich-content-common/lib/devTools";
import {
  hasWixInsiderOverride,
  OverrideFullRicosEditorLazy,
  OverridePluginsResolver
} from "./../wix-rich-content-common/lib/overrides";
import { isiOS } from "./../editor-common";
import { loadCSS } from "./load-css";
import { RicosErrorBoundary } from "./tiptap/RicosErrorBoundary";
const FullRicosEditorLazy = React.lazy(() => {
  loadCSS();
  return import(
    /* webpackChunkName: "ricos_FullRicosEditor" */
    "./tiptap/FullRicosEditor"
  );
});
const LocaleResourceProviderLazy = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_LocaleResourceProvider" */
    "./RicosContext/locale-resource-provider"
  )
);
const renderMobileDevTools = () => {
  if (typeof window !== "undefined" && !window.__RICOS_DEVTOOLS_MOBILE_HOOK__) {
    window.__RICOS_DEVTOOLS_MOBILE_HOOK__ = true;
    const cdnTag = document.createElement("script");
    cdnTag.src = "//cdn.jsdelivr.net/npm/eruda";
    cdnTag.onload = () => {
      eruda.init();
    };
    window.document.head.appendChild(cdnTag);
  }
};
const RicosEditor = forwardRef(
  (props, ref) => {
    if ((props.debugMode?.includes("mobile") || props.debugMode?.includes("all")) && props.isMobile) {
      renderMobileDevTools();
    }
    const loadingPlaceholder = props.loadingPlaceholder || /* @__PURE__ */ React.createElement("div", null);
    const Wrapper = shouldShowDebuggingInfo(props.debugMode?.includes("all")) ? DevContextProvider : React.Fragment;
    const FullRicosEditorComp = hasWixInsiderOverride ? OverrideFullRicosEditorLazy : FullRicosEditorLazy;
    return isSSR() ? /* @__PURE__ */ React.createElement("div", null) : /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(RicosErrorBoundary, { onError: props.onError }, /* @__PURE__ */ React.createElement(Suspense, { fallback: loadingPlaceholder }, /* @__PURE__ */ React.createElement(LocaleResourceProviderLazy, { fallback: loadingPlaceholder, locale: props.locale }, (locale) => (t) => /* @__PURE__ */ React.createElement(
      OverridePluginsResolver,
      {
        hasOverride: hasWixInsiderOverride,
        plugins: props.plugins
      },
      (plugins) => /* @__PURE__ */ React.createElement(
        FullRicosEditorComp,
        {
          ...props,
          plugins,
          locale,
          t,
          ref,
          platform: isiOS() ? "macOs" : "windows"
        }
      )
    )))));
  }
);
RicosEditor.displayName = "RicosEditor";
export {
  RicosEditor
};
//# sourceMappingURL=RicosEditor.js.map
